export function toTitleCase(str = '') {
  return str.toLowerCase().replace(/\b\w/g, function(char) {
    return char.toUpperCase();
  });
}

export function toTitleCaseFromUnderscore(str) {
  // Replace underscores with spaces
  let withSpaces = str.replace(/_/g, " ");
  // Capitalize the first letter of each word
  let titleCased = withSpaces.replace(/\b\w/g, char => char.toUpperCase());
  return titleCased;
}